import React, { useState } from "react";
import section2img from "../assests/HomeImg/section2-img.svg";
import "./index.css";

// Board Images - Updated from boardOfDirectors_images
import boardImg1 from "../assests/boardOfDirectors_images/Image-1.png";
import boardImg2 from "../assests/boardOfDirectors_images/Image-2.png";
import boardImg3 from "../assests/boardOfDirectors_images/Image-3.png";
import boardImg4 from "../assests/boardOfDirectors_images/Image-4.png";
import boardImg5 from "../assests/boardOfDirectors_images/Image-5.png";
import boardImg6 from "../assests/boardOfDirectors_images/Image-6.png";
import boardImg7 from "../assests/boardOfDirectors_images/Image-7.png";

const boardOfDirectors = [
    { image: boardImg1, name: "Dr. Kamal Sharma", role: "Chairman & Independent Director", description: "Dr. Kamal Sharma has over 48 years of professional experience in executive positions in the Chemical and Pharmaceutical industries and has essayed a wide variety of roles in operations, corporate development and executive management. As the Managing Director of Lupin for a decade between 2003-13, he was instrumental in Lupin achieving leadership position in key markets and businesses, transforming it into one of the largest and fastest growing pharmaceutical companies globally. Previously, he also served as President & Chief Executive of the Life Sciences and speciality group and Member of the Management Board at RPG Enterprises. Mr. Sharma received a Bachelors Degree in Chemical Engineering from IIT Kanpur, a post graduate diploma in Industrial Management from Jamnalal Bajaj Institute of Management Studies and a PhD in Economics from IIT, Mumbai. He has also attended Advanced Management Program (AMP) at Harvard Business School, Boston." },
    { image: boardImg2, name: "Dr. Haribabu Bodepudi", role: "Managing Director & Group CEO", description: "Dr. Haribabu holds a PhD in Organic Chemistry and has over 30 years of experience in the global pharmaceutical industry. He has held various leadership roles in multinational companies and has extensive expertise in pharmaceutical development, regulatory strategy, and global supply chain management." },
    { image: boardImg3, name: "Mr. Rajaram Narayanan", role: "Executive Director and CEO – Animal Health", description: "With over 25 years of experience, Mr. Narayanan has a strong track record of leading growth across multiple industries. He previously served as the Managing Director and Country Chair for Sanofi India Limited and held leadership roles at Hindustan Unilever Ltd for over 18 years." },
    { image: boardImg4, name: "Mr. Srinivas Vasireddy", role: "Executive Director", description: "Mr. Srinivas Vasireddy brings 37 years of extensive experience across all facets of API operations. Prior to joining the Company, he served as Head of API (Special Projects) at Mylan Laboratories, focusing on manufacturing, quality, and compliance." },
    { image: boardImg5, name: "Mr. Anuj Poddar", role: "Non-Executive Director", description: "Anuj Poddar is a Managing Director at Carlyle. He previously served as the MD & CEO of Bajaj Electricals and was a founding team member of Viacom18 Media. He is a rank-holding Chartered Accountant and an Aspen Fellow." },
    // { image: boardImg6, name: "Dr. Fabian Kausche", role: "Non Executive Director", description: "Dr. Kausche has several decades of experience in the animal and human health industries. He held subsequent positions as Global Head of R&D for Novartis Animal Health, Merial, and Boehringer Ingelheim Animal Health." },
    // { image: boardImg7, name: "Mr. Gregory Andrews", role: "Non-executive Director", description: "Greg is a multi-disciplinary executive with 30 years of commercial experience in the pharmaceutical industry. He has held executive positions within three of the major animal health companies and was the Global Marketing Director for Virbac." },
    { image: boardImg6, name: "Mr. Milind Sarwate", role: "Independent Director", description: "Milind Sarwate is the Founder & CEO of Increate Value Advisors LLP. \"Increate\" means \"Uncreated\" or \"Undiscovered\". Milind set up Increate in 2015 as his second career as an entrepreneur, to help organizations & individuals discover, develop & deliver business & social value. For this, he contributes as required - as Advisor, Mentor, Board Member, or Investor, leveraging his 37-year experience including long stints in Marico & Godrej. His Advisory roles in Business Value Creation encompass the following: Helping Private Equity Investors enhance Investee Companies' value, especially in Consumer / Retail Sectors, across listed and unlisted companies. Mentoring promoters and corporate professionals for effective Promotership & Governance. Capability building and Enhancing effectiveness of Corporate functions, like Finance, HR & Strategy. Maximizing Value in IPOs / M & As / Corporate Structuring. His Advisory roles in Social Value Creation cover: Guiding Companies in CSR strategy and execution. Helping Non - Profit Organizations grow and widen their social impact. Being the middleware between the Social Sector and the Corporate Business sector. His Directorships include 5 listed companies - Mahindra Finance, Hexaware, Glenmark, Metropolis, Matrimony.com - and 3 unlisted companies - OmniActive Health Technologies, Eternis Fine Chemicals and WheelsEMI, all with focus on the audit committee. He also plays Advisory Board role in Bruhat Insights Global, a start up in Artificial Intelligence in HR, and Educo, a School Support NGO. He invests in promising business / social enterprises(largely SMEs), by way of venture and angel capital. He has been awarded ICAI CFO Award(2011), CNBC TV - 18 CFO Award(2012) & CFO India Hall of Fame induction(2013). Milind is a Chartered Accountant, Cost Accountant, Company Secretary and Commerce Graduate. He is a CII - Fulbright Fellow(Carnegie Mellon University, U S A)." },
    { image: boardImg7, name: "Ms. Revati Kasture", role: "Independent Director", description: "Revati Kasture has over two decades of experience in ratings and research. She is currently the Executive Director of Care Ratings Limited and CEO of CareEdge Global IFSC Limited." }
];
export const committeesData = [
    {
        title: "I. Audit Committee",
        members: [
            {
                id: 1,
                name: "Mr. Milind Shripad Sarwate",
                role: "Independent Director, Chairman",
            },
            {
                id: 2,
                name: "Dr. Kamal Kishore Sharma",
                role: "Independent Director, Member",
            },
            {
                id: 3,
                name: "Mr. Abhiroop Jayanthi",
                role: "Non-Executive Director, Member",
            },
            {
                id: 4,
                name: "Ms. Revati Parag Kasture",
                role: "Independent Director, Member",
            },
        ],
    },
    {
        title: "II. Nomination and Remuneration Committee",
        members: [
            {
                id: 1,
                name: "Mr. Milind Sarwate",
                role: "Chairman",
            },
            {
                id: 2,
                name: "Dr. Kamal Sharma",
                role: "Member",
            },
            {
                id: 3,
                name: "Mr. Amit Jain",
                role: "Member",
            },
        ],
    },
    {
        title: "III. Stakeholders Relationship Committee",
        members: [
            {
                id: 1,
                name: "Ms. Revati Parag Kasture",
                role: "Independent Director, Chairperson",
            },
            {
                id: 2,
                name: "Mr. Milind Shripad Sarwate",
                role: "Independent Director, Member",
            },
            {
                id: 3,
                name: "Mr. Rajaram Narayanan",
                role: "Managing Director, Member",
            },
            {
                id: 4,
                name: "Dr. Haribabu Bodepudi",
                role: "Managing Director & Group CEO",
            },
        ],
    },
    {
        title: "IV. Corporate Social Responsibility Committee",
        members: [
            {
                id: 1,
                name: "Dr. Kamal Sharma",
                role: "Chairman",
            },
            {
                id: 2,
                name: "Mr. Rajaram Narayanan",
                role: "Member",
            },
            {
                id: 3,
                name: "Dr. Hari Babu Bodepudi",
                role: "Member",
            },
        ],
    },
    {
        title: "V. Risk Management Committee",
        members: [
            { id: 1, name: "Mr. Abhiroop Jayanthi", role: "Chairman" },
            { id: 2, name: "Mr. Milind Sarwate", role: "Member" },
            { id: 3, name: "Mr. Rajaram Narayanan", role: "Member" },
            { id: 4, name: "Dr. Haribabu Bodepudi", role: "Member" },
            { id: 5, name: "Ms. Revati Kasture", role: "Member" },
            { id: 6, name: "Mr. Ramakant Singani", role: "Member" },
        ],
    },
    {
        title: "Committees of the Board of Alivira Animal Health Limited",
        isFullWidth: true, // 👈 important
        members: [],
    },
    {
        title: "I. Corporate Social Responsibility Committee",
        isFullWidth: true, // 👈 important
        members: [
            { id: 1, name: "Dr. Kamal Sharma", role: "Chairman" },
            { id: 2, name: "Mr. Rajaram Narayanan", role: "Member" },
            { id: 3, name: "Mr. Srinivas Vasireddy", role: "Member" },
        ],
    }
];

const BoardOfDirectors = () => {
    const [selectedDirector, setSelectedDirector] = useState(null);

    return (
        <>

            <div className="board-page">
                {/* HERO - Styled like Finance */}
                <section className="fin-hero">
                    <div className="fin-hero-content">
                        <h1>Board of Directors</h1>
                        <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                        <p>Guidance and governance from industry veterans and subject matter experts committed to ethical growth.</p>
                    </div>
                </section>

                {/* BREADCRUMB - Styled like Finance */}
                {/* <div className="board-breadcrumb">
                <div className="wrapper">
                    <Link to="/"><HomeIcon /> Home</Link>
                    <span>›</span>
                    <span className="current">Board of Directors</span>
                </div>
            </div> */}

                {/* CONTENT AREA - Styled like Finance */}
                <section className="fin-content">
                    <div className="fin-content-inner">
                        <div className="fin-filter-bar">
                            <div className="fin-filter-left">
                                <h2 className="fin-section-title">Governing Board</h2>
                                <span className="fin-result-count">{boardOfDirectors.length} Directors</span>
                            </div>
                        </div>

                        <div className="board-grid-wrap">
                            <div className="board-grid">
                                {boardOfDirectors.map((director, index) => (
                                    <div key={index} className="director-card" onClick={() => setSelectedDirector(director)}>
                                        <div className="director-image-container">
                                            <img src={director.image} alt={director.name} />
                                            <div className="view-bio-overlay">View Bio</div>
                                        </div>
                                        <div className="director-info">
                                            <h3>{director.name}</h3>
                                            <p>{director.role}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>

                {/* BIO MODAL - Premium Modal */}
                {selectedDirector && (
                    <div className="bio-modal-overlay" onClick={() => setSelectedDirector(null)}>
                        <div className="bio-modal-content" onClick={(e) => e.stopPropagation()}>
                            <button className="bio-modal-close" onClick={() => setSelectedDirector(null)}>×</button>
                            <div className="bio-modal-body">
                                <div className="bio-modal-image">
                                    <img src={selectedDirector.image} alt={selectedDirector.name} />
                                </div>
                                <div className="bio-modal-text">
                                    <h2>{selectedDirector.name}</h2>
                                    <h4 className="role">{selectedDirector.role}</h4>
                                    <div className="bio-divider"></div>
                                    <p>{selectedDirector.description}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            {/* <div className="committees-container">
                <h1 className="main-title">
                    Committees of the Board of The Company
                </h1>

                <div className="grid">
                    {committeesData.map((committee, index) => (
                        <div key={index} className="committee-card">
                            <h2 className="committee-title">{committee.title}</h2>

                            <div className="table">
                                {committee.members.map((member) => (
                                    <div key={member.id} className="row">
                                        <div className="cell index">{member.id}</div>
                                        <div className="cell name">{member.name}</div>
                                        <div className="cell role">{member.role}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div> */}
            <div className="committees-container">
                <h1 className="main-title">
                    Committees of the Board of The Company
                </h1>

                <div className="grid">
                    {committeesData.map((committee, index) => {
                        // Section title only (no table)
                        if (committee.members.length === 0) {
                            return (
                                <div key={index} className="full-width">
                                    <h1 className="section-main-title">
                                        {committee.title}
                                    </h1>
                                </div>
                            );
                        }

                        return (
                            <div
                                key={index}
                                className={
                                    committee.isFullWidth
                                        ? "committee-card full-width"
                                        : "committee-card"
                                }
                            >
                                <h2 className="committee-title">{committee.title}</h2>

                                <div className="table">
                                    {committee.members.map((member) => (
                                        <div key={member.id} className="row">
                                            <div className="cell index">{member.id}</div>
                                            <div className="cell name">{member.name}</div>
                                            <div className="cell role">{member.role}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export default BoardOfDirectors;
